import { Box, Icon, InputAdornment } from '@mui/material'
import CandidateList from './CandidateList'
import { useState } from 'react'
import CandidateDrawer from './CandidateDrawer'
import AdxInput from 'components/custom/AdxInput'
import { useNavigate } from 'react-router-dom'
import { useDebouncedEffect } from 'services/hooks/useDebouncedEffect'
import {
  AppliedAndMatchedColumn,
  HiredColumn,
  InterviewColumn,
  OfferColumn,
  ShortlistedColumn,
} from './CandidateColumn'
import SearchFilterPopper from './SearchFilterPopper'
const CandidateTable = ({
  handleChangePage,
  dataCandidate,
  error,
  lastPage,
  isLoading,
  totalInCart,
  jobId,
  page,
  rowsPerPage,
  handleChangeRows,
  count,
  type,
  cartHasItem,
  setFilter,
  setApplicationId,
  setSearch,
  search,
}) => {
  const navigate = useNavigate()
  //for table column
  let columnProps
  switch (type) {
    case 'matched':
    case 'applied':
      columnProps = AppliedAndMatchedColumn
      break
    case 'shortlisted':
    case 'rejected':
      columnProps = ShortlistedColumn
      break
    case 'interview':
      columnProps = InterviewColumn
      break
    case 'offered':
      columnProps = OfferColumn
      break
    case 'hired':
      columnProps = HiredColumn
      break
  }

  // drawer logic
  const [data, setData] = useState([])
  const [isChoosenName, setIsChoosenName] = useState([])
  const [isChoosenId, setIsChoosenId] = useState([])
  const changeApplicantDetail = (info) => {
    setIsChoosenId(info?.id)
    setData(info)
    // to set which candidate is clicked at drawer list
    setIsChoosenName(info?.relations?.candidateable?.name)
  }
  const [drawerState, setDrawerState] = useState({ right: false })
  const handleDrawer = (anchor, open) => (event) => {
    setDrawerState({ ...drawerState, [anchor]: open })
    setData(event)
  }
  const handleDrawerClose = (anchor, open) => {
    setDrawerState({ ...drawerState, [anchor]: open })
  }

  //search item
  const [searchItem, setSearchItem] = useState('')
  const handleClearSearch = () => {
    setSearchItem('')
  }

  // set delay for search api
  useDebouncedEffect(
    () => {
      if (searchItem.length > 0) {
        setSearch(`&search=${searchItem}`)
      } else {
        setSearch('')
      }
    },
    [searchItem],
    1000
  )

  return (
    <Box>
      {dataCandidate?.length > 0 && (
        <Box
          sx={{
            width: 1,
            borderBottom: '1px solid',
            borderColor: 'gray-line.main',
          }}
          display="flex"
          columnGap={2}
          padding={2}
          justifyContent="space-between"
          alignItems="center"
          bgcolor="white.main"
        >
          <Box
            sx={{
              width: 1,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'start',
              alignItems: 'center',
              gap: '14px',
            }}
          >
            <Box>
              <SearchFilterPopper
                type={type}
                setFilter={setFilter}
                setApplicationId={setApplicationId}
                resetFilter={() => setFilter('')}
              />
            </Box>
            <AdxInput
              placeholder="Search name"
              value={searchItem}
              onChange={(e) => setSearchItem(e.target.value)}
              sx={{
                width: { xs: 1, sm: 1 / 3, lg: '40%' },
                '& .MuiInputBase-root': {
                  outline: '2px solid',
                  outlineColor: '#E5E5E5',
                  bgcolor: 'white.main',
                },
              }}
              startAdornment={
                <InputAdornment position="start">
                  <Icon>search</Icon>
                </InputAdornment>
              }
              endAdornment={
                searchItem ? (
                  <InputAdornment position="end">
                    <Icon
                      onClick={handleClearSearch}
                      sx={{ color: 'error.main', cursor: 'pointer' }}
                    >
                      close
                    </Icon>
                  </InputAdornment>
                ) : null
              }
            />
          </Box>

          {/* TODO Hhide for pithcing */}
          {/* <Box display="flex" alignItems="center" onClick={() => navigate(`/app/recruitment/cart`)}>
          {cartHasItem > 0 ? (
            <Badge color="error" variant="dot">
              <Icon
                sx={{
                  color: 'alternate.main',
                  cursor: 'pointer',
                }}
              >
                shopping_cart
              </Icon>
            </Badge>
          ) : (
            <Icon
              sx={{
                color: 'alternate.main',
                cursor: 'pointer',
              }}
            >
              shopping_cart
            </Icon>
          )}
          <Box display="flex" alignItems="flex-start" height={40}>
            {totalInCart > 0 ? <Icon sx={{ fontSize: 8, color: 'error.main' }}>circle</Icon> : null}
          </Box>
        </Box> */}
        </Box>
      )}

      <Box>
        <CandidateList
          column={columnProps}
          data={dataCandidate ?? []}
          nav="View"
          onClick={handleDrawer('right', true)}
          sxHeader
          sxNav
          sxCell
          sx
          lastPage={lastPage}
          count={count}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRows}
          allAplicantIsLoading={isLoading}
          error={error}
          title={type}
          searchItem={searchItem}
          setIsChoosenName={setIsChoosenName}
          setIsChoosenId={setIsChoosenId}
        />
      </Box>
      <CandidateDrawer
        mappedData={dataCandidate ?? []}
        changeApplicantDetail={changeApplicantDetail}
        data={data}
        drawerState={drawerState}
        handleDrawer={handleDrawer}
        handleDrawerClose={handleDrawerClose}
        title={type}
        count={count}
        jobId={jobId}
        isChoosenName={isChoosenName}
        isChoosenId={isChoosenId}
        setSearch={setSearch}
        //need search item to be passed in drawer because search function is accessible in the table and also drawer
        searchItem={searchItem}
        setSearchItem={setSearchItem}
        isLoading={isLoading}
        error={error}
      />
    </Box>
  )
}

export default CandidateTable
